export default "__VITE_ASSET__4f5d9776__"